<!-- 选择建筑房间组件 支持每级建筑选择，支持最后一集选择 -->
<template>

    <div style="position: relative;min-width:300px;">
        <div class="newres-select el-input el-input--medium" @click.stop="handleOpen">
            <p class="el-input__inner" style="display:inline-block;cursor: pointer;position: relative;">
                <span>{{value}}</span>
                <span class="placeholder" v-if="value == ''">请选择房间号</span>
                <i class="el-icon-error el-icon--right" v-else style="position: absolute;right: 10px;top: 11px;" @click.stop="clearValue"></i>
            </p>
        </div>
        <transition name="fade">
            <div class="select-box" v-if="isOpenResidence" v-clickoutside="handleOpenF">
                <div class="build-header">
                    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane
                            v-for="(item, index) in tabList"
                            :key="index"
                            :label="item.typename"
                            :name="item.oid"
                        >
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="build-body" v-loading="loading">
                    <template v-for="(v, i) in dataList">
                        <span :class="fmtChose(v.oid) ? 'build-item icon-btn icon-btn-active': 'build-item icon-btn'" :key="i" @click="handleClickRoom(v)">{{v.modulename}}</span>
                    </template>
                    <div v-if="dataList.length==0" style="margin:10px auto;text-align:center;color:#ccc;font-size:14px;">暂无可绑定的房间。<router-link to="/residence">去添加房间</router-link></div>
                </div>
                <div class="build-foot">
                    <el-button type="primary" class="fr" size="medium" @click="handleResult">确认</el-button>
                </div>
            </div>
        </transition>
    </div>

</template>

<script>
import Service from '@/api/Service'

export default {
    name: "CmpBuildSelectbind",
    props: ["buildRoom", "changeOnSelect", 'selectType', "disabled"],     //  buildRoom: 初始值；changeOnSelect：是否支持每级查询
    data() {
        return {
            value: '',  //  显示内容
            choseValue: [],
            choseItem: {},
            isOpenResidence: false,     //  建筑列表框

            tabList: [],   //  选项头部

            dataList: [],   //  建筑列表
            isRoom: false,  // 是否点击房间

            choseHouseOID: [], //  选择的房间
            choseHouseList: [], //  选择的房间

            activeName: 0,
            loading: false,
			
			roomarr:[],
			building_index:0,
        };
    },
    created() {
        this.initData();
    },
    watch: {
        buildRoom: {
            handler(newName, oldName) {
                this.initData()
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        initData() {
           if(this.buildRoom.houseName) {
               this.value = this.buildRoom.houseName
               this.choseHouseList = this.buildRoom.choseHouseList;
           }
        },
        // 获取列表
        async getListData(oid, isendpoint) {
            let data
            this.loading = true;    //  开启加载动画
            if(isendpoint){
				this.$store.dispatch("GetProjectInfo").then(async res => {
				    // 获取模型结构
				    Service.getTemplate({oid:res.buildings_template_id}).then(async ress => {
						this.roomarr = this.fmdata(JSON.parse(ress.description))
						this.building_index=this.roomarr[this.roomarr.length - 1].id
						let selectType = this.selectType;
						// 获取房间
						// let newData = await Service.getHouseList({OID: oid,building_index:this.building_index,house_name:''});
                        let newData = await Service.getNoBindHouseList({OID: oid});
						newData = newData === 'success' ? [] : newData;
						newData.map(v=>{
						    v.modulename = v.housename
						})
						data = newData.filter(v=>{
						    return v[selectType] == 0;
						})
						if(data){
						    this.dataList = newData;
						    this.setTab(oid, data[0]);
						}
				    })
				}).catch(res=>{
					
				})
                
                // data = newData
                this.isRoom = true;
            }else{
                // 获取建筑
                let res = await Service.getBuildList({OID: oid});
                data = res.list === null ? [] : res.list;
                this.isRoom = false;
				if(data){
				    this.dataList = data;
				    this.setTab(oid, data[0]);
				}
            }
            
            this.loading = false;   //  关闭加载动画
        },
        fmdata(data){
			return data.reduce((arr, { id, typename, children = [] }) =>
				arr.concat([{ id, typename }], this.fmdata(children)), [])
		},
        fmtChose(oid) {
            let arr = [];
            arr = this.choseHouseList.filter(v=>{
                return v.oid === oid
            })
            return arr.length>0
        },
        // 打开建筑框   重置数据
        handleOpen() {
            if(this.disabled) return;
            this.choseValue = [];
            this.choseItem = {};
            this.tabList = [];
            this.isOpenResidence = true;
            this.getListData(0);
        },
        // 关闭建筑框
        handleOpenF() {
            this.isOpenResidence = false;
        },
        // 关闭建筑框
        handleHouseClick() {
            let item = this.choseItem;            
            let index = -1
            this.choseHouseList.forEach((v,i) => {
                if(v.oid === item.oid) {
                    index = i
                }
            })
            index >= 0 ? this.choseHouseList = this.choseHouseList.filter(v=>v.oid !== item.oid): this.choseHouseList.push(item)
            let a = []
            this.choseHouseList.map(v=>{
                a.push(v.modulename)
            })
            this.value = a.join(" / ")
        },
        // 确认
        handleResult() {
            
            this.$emit('listenBuildResult', this.choseHouseList)
            this.isOpenResidence = false;
        },
        // 清空
        clearValue() {
            if(this.disabled) return;
            this.value = "";
            this.choseItem = {};
            this.choseHouseList = [];
            this.handleOpen();
        },
        // 点击建筑
        handleClickRoom(item) {
            this.choseItem = item;
            this.choseValue.push(item.modulename);

            if(item.housename){
                // 确认房间信息
                this.handleHouseClick();
            }else{
                // 获取下级数据
                this.getListData(item.oid, item.isendpoint);
            }
        },
        // 设置头部tab
        setTab(oid, item){
            if(!item) return
            this.tabList.push({
                oid: oid + "",
                typename: item.typename || "房间"
            })
            this.activeName = oid + "";
        },
        // 点击头部tab
        handleClick(tab, event) {
            if(event) {
                event.stopPropagation ? event.stopPropagation(): event.cancelBubble = true;
            }
            let index = tab.index
            let oid = tab.name;
            this.tabList = this.tabList.filter((v,i)=>{
                return i<index
            })
            this.choseValue = this.choseValue.filter((v,i)=>{
                return i<index
            })
            // this.value = this.choseValue.join(' / ');
            this.getListData(oid);
        }
    }
};
</script>

<style scoped lang="less">
.select-box {
    position: absolute;
    width: 100%;
    padding: 12px 24px;
    border: 1px solid #ddd;
    background: #fff;
    box-sizing: border-box;
    z-index: 9999;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
}
.build-body{
    line-height: 28px;
    font-size: 0;
}
.build-item{
    display: inline-block;
    margin: 0 10px;
    font-size: 14px;
}

.icon-btn-active{
    color: @primary-color;
}


</style>
